module.exports = __webpack_public_path__ + "src/assets/img/index_img6.fb421890.jpg";